<script type='text/babel'>
import { mapActions, mapGetters, mapMutations } from 'vuex';
// import objectPath from 'object-path';
import shortId from 'shortid';
export default {
    name: 'DragAndDropMixin',
    computed: {
        ...mapGetters({
            currentLayout : 'getCurrentLayout',
            oldPath: 'getElementsOldPath',
            dragged: 'getDraggedElement',
            dragData: 'getDragData',
            targetPath: 'getTargetPath'
        })
    },
    methods: {
        ...mapActions([
            'addElementAction',
            'getElementFromSchema',
            'destroyElement'
        ]),
        ...mapMutations([
            'setElementsOldPath',
            'setDragData',
            'setTargetPath'
        ]),
        dragstart_handler (ev, element, path, newLayer) {
            ev.stopPropagation();
            let newElement = element;
            if(newLayer) {
                newElement = this.$utils.deepClone(element);
            }
            newElement.attrs.domProps.id = shortId.generate();
            ev.dataTransfer.effectAllowed = 'move';
            ev.dataTransfer.dragEffect = 'move';
            ev.dataTransfer.setData('text/plain', null);
            this.setElementsOldPath(path);
            this.setDragData(newElement);
        },
        dragover_handler (ev, path) {
            ev.preventDefault();
            ev.stopPropagation();
            ev.dataTransfer.dropEffect = 'move';
            if(!path || path && path === this.targetPath) {
                return;
            }
            this.setTargetPath(path);
        },
        drop_handler (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            if(this.dragData) {
                this.addElementAction({
                    path: this.targetPath,
                    oldPath: this.oldPath,
                    value: this.dragData
                });
            }
            this.setDragData({});
        },
        dragend_handler (ev) {
            ev.dataTransfer.clearData();
            ev.target.style.border = '';
        }
    }
};
</script>
